var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10C17.5 9.50272 17.3025 9.02581 16.9508 8.67417C16.5992 8.32254 16.1223 8.125 15.625 8.125H12.5C12.5 8.78804 12.2366 9.42393 11.7678 9.89277C11.2989 10.3616 10.663 10.625 10 10.625C9.33696 10.625 8.70107 10.3616 8.23223 9.89277C7.76339 9.42393 7.5 8.78804 7.5 8.125H4.375C3.87772 8.125 3.40081 8.32254 3.04917 8.67417C2.69754 9.02581 2.5 9.50272 2.5 10M17.5 10V15C17.5 15.4973 17.3025 15.9742 16.9508 16.3258C16.5992 16.6775 16.1223 16.875 15.625 16.875H4.375C3.87772 16.875 3.40081 16.6775 3.04917 16.3258C2.69754 15.9742 2.5 15.4973 2.5 15V10M17.5 10V7.5M2.5 10V7.5M17.5 7.5C17.5 7.00272 17.3025 6.52581 16.9508 6.17417C16.5992 5.82254 16.1223 5.625 15.625 5.625H4.375C3.87772 5.625 3.40081 5.82254 3.04917 6.17417C2.69754 6.52581 2.5 7.00272 2.5 7.5M17.5 7.5V5C17.5 4.50272 17.3025 4.02581 16.9508 3.67417C16.5992 3.32254 16.1223 3.125 15.625 3.125H4.375C3.87772 3.125 3.40081 3.32254 3.04917 3.67417C2.69754 4.02581 2.5 4.50272 2.5 5V7.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallets);
export default __webpack_public_path__ + "static/media/wallets.9c42039f953fecb04075e978b2f334c5.svg";
export { ForwardRef as ReactComponent };